export const templates = [

    {
        name: "@system/mobile/addons/authentication/user-profile/loader",
        loader: () => import("./UserIdentityLoader"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/authentication/user-profile/menu-item",
        loader: () => import("./UserProfileMenuItemAuthentication"),
        pure: true,
    },





    {
        name: "@system/mobile/addons/authentication/default-name-card",
        loader: () => import("./ListViewDefaultNameCard"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/authentication/validation-tag",
        loader: () => import("./CertificationValidationTag"),
        pure: true,
    },
    {
        name: "@system/mobile/addons/authentication/invalid-notice",
        loader: () => import("./CertificationInvalidNotice"),
        pure: true,
    },
];